export const ageOptions = Array(5)
  .fill(null)
  .map((_, index) => ({ label: `${index + 15} years`, value: `${index + 15}` }));
